import {useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals_action/affiliate-signup/index';
import WelcomeBonusSelector from '../../../selectors/modals_action/affiliate-signup/welcome_bonus';
import {toggleActionModal, AffiliateSignup} from '../../../reducers/modals-action/actions';
import Choose from './choose';
import SignUp from './signup';
import PhoneConfirmation from './phone_confirmation';
import PhoneChange from './phone-change';
import Status from './status';
import Notifications from './notifications';

export default ({index}) => {
    const {stage, game, user} = useSelector(Selector),
          welcome_bonus = useSelector(WelcomeBonusSelector),
          dispatch = useDispatch();

    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__slideInUp');
            modal.current.classList.add('animate__fadeOut');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('affiliate_signup')); 
        }, 500);
    }

    useEffect(() => {
        if(welcome_bonus && welcome_bonus.status === 0) {
            if(user.phone.status !== 'confirmed')
                dispatch(AffiliateSignup.setStage('phone_confirmation'));
            else
                dispatch(AffiliateSignup.setStage('notifications'));
        }

        if(welcome_bonus && welcome_bonus.status === 1)
            dispatch(AffiliateSignup.setStage('status'));

        if(welcome_bonus && welcome_bonus.status === 2)
            closeAction();
    }, [welcome_bonus]);

    return (
        <div className="action-modal-fix affiliate-signup">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className={`${stage !== 'choose' ? 'modal auth' : ''} action-modal animate__animated animate__slideInUp animate__faster`} ref={modal}>
                    {stage === 'notifications' && <Notifications game={game} close={closeAction} />}
                    {stage === 'choose' && <Choose game={game} close={closeAction} />}  
                    {stage === 'signup' && <SignUp game={game} close={closeAction} />}
                    {stage === 'phone_confirmation' && <PhoneConfirmation game={game} close={closeAction} />}  
                    {stage === 'phone_change' && <PhoneChange game={game} close={closeAction} />}  
                    {stage === 'status' && <Status game={game} close={closeAction} />}  
                </div>
            </div>
        </div>
    )
}